"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = useDetailedProductsList; // Api calls

exports.default = _default;

function get_products_api(gql_url) {
  let data = JSON.stringify({
    query: `query legacyListProducts{  
      legacyListProducts{
        id     
        price
        title
    }
  }`,
    variables: {}
  });
  let config = {
    method: "post",
    url: gql_url,
    headers: {
      "Content-Type": "application/json"
    },
    data: data
  };
  return (0, _axios.default)(config);
}

function get_categories_api(gql_url) {
  let childrenData = `id
  title
  icon
  description 
  banner_text
  on_offer
  image_url
  products`;
  let data = JSON.stringify({
    query: `query legacyListCategories{  
      legacyListCategories{
        ${childrenData}
        children {
          ${childrenData}
          children {
          ${childrenData}
          children {
          ${childrenData}
          children {
            ${childrenData}
            }
          }
        }
      }
    }
  }`,
    variables: {}
  });
  let config = {
    method: "post",
    url: gql_url,
    headers: {
      "Content-Type": "application/json"
    },
    data: data
  };
  return (0, _axios.default)(config);
}

function output(categories, products) {
  const reducer = item => {
    if (item && item.products) {
      // console.log({ products: item.products });
      item.products = item.products.map(id => products.find(product => product.id == id)).filter(filterd => filterd); // console.log({ products2: item.products });
    }

    if (item && item.children && item.children.length) item.children = item.children.map(inside_item => reducer(inside_item));
    return item;
  };

  let output = categories.reduce((acc, current) => {
    let cloned = JSON.parse(JSON.stringify(current));
    const replaced = reducer(cloned);
    acc.push(replaced);
    return acc;
  }, []);
  return output;
}

function useDetailedProductsList({
  gql_url
}) {
  let [loading, setLoading] = (0, _react.useState)(true);
  let [categories, setCategories] = (0, _react.useState)([]);
  let [products, setProducts] = (0, _react.useState)([]);
  let revalidate = (0, _react.useCallback)(function revalidate() {
    setLoading(true);
    Promise.all([get_products_api(gql_url), get_categories_api(gql_url)]).then(responses => {
      let products = responses[0].data.data.legacyListProducts;
      let categories = responses[1].data.data.legacyListCategories;
      setProducts(products);
      setCategories(categories);
    }).finally(() => {
      setLoading(false);
    });
  }, []);
  (0, _react.useEffect)(() => {
    revalidate();
  }, []);
  return {
    revalidate,
    loading,
    data: output(categories, products)
  };
}